import React from 'react';
import { inject, observer } from 'mobx-react';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import 'react-day-picker/lib/style.css';
import { differenceInDays, subDays } from 'date-fns';

import config from '../../config';
import SettingsModal from './SettingsModal';
import logo from './logo.svg';
import '../../styles/components/FilterBar.css';

const MONTHS = [
  'januari',
  'februari',
  'maart',
  'april',
  'mei',
  'juni',
  'juli',
  'augustus',
  'september',
  'oktober',
  'november',
  'december',
];
const WEEKDAYS_LONG = [
  'zondag',
  'maandag',
  'dinsdag',
  'woensdag',
  'donderdag',
  'vrijdag',
  'zaterdag',
];
const WEEKDAYS_SHORT = ['zo', 'ma', 'di', 'wo', 'do', 'vr', 'za'];

export default inject('filterStore', 'planStore')(
  observer(class FilterBar extends React.Component {
    constructor() {
      super();
      this.openSettings = this.openSettings.bind(this);
      this.changeDate = this.changeDate.bind(this);
    }

    openSettings() {
      this.props.filterStore.toggleModal(true);
    }

    changeDate(date) {
      const firstDate = subDays(new Date(), config.startDateOffset * -1);
      const diff = differenceInDays(date, firstDate);

      if (diff >= 0) {
        this.props.planStore.setSkipToColumn(diff);
      }
    }

    render() {
      return (
        <div className='filterbar'>
          <img className='filterbar__logo' src={logo} alt='De Wilde logo' />

          <div className="filterbar__content">
            <DayPickerInput
              placeholder="Selecteer datum"
              format="DD/MM/YYYY"
              dayPickerProps={{
                firstDayOfWeek: 1,
                months: MONTHS,
                weekdaysLong: WEEKDAYS_LONG,
                weekdaysShort: WEEKDAYS_SHORT,
              }}
              onDayChange={this.changeDate}
            />
          </div>

          <SettingsModal />
        </div>
      );
    }
  })
);



// WEBPACK FOOTER //
// ./src/components/FilterBar/index.js